export default "__VITE_ASSET__BnygVB4j__"